export default __webpack_public_path__ + "maps-overview-circle-layer-1200-5446b9240a4c06514a5ca70d7dc427b5.webp";